import React, {Fragment, useState, useRef} from 'react';
import EditIcon from '@material-ui/icons/Edit';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { Field} from 'react-final-form';
import TextField from '@material-ui/core/TextField';
import DealDetailsSection from '../../../../../../../components/FormSections/Fields/DealDetailsSection';
import CustomFieldsSection from '../../../../../../../components/FormSections/Fields/CustomFieldsSection';
import {Form, Popup, Select, Radio, Date_picker, Text, MultipleSelect} from '../../../../../../../components';
import ForwardIcon from '@material-ui/icons/Forward';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AddIcon from '@material-ui/icons/Add';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InfoIcon from '@material-ui/icons/Info';
import ImageIcon from '@material-ui/icons/Image';
import CancelIcon from '@material-ui/icons/Cancel';
import {connect} from 'react-redux';


function Deal_popup_form(props){
  const[error, setError]=useState({});
  const[open_section, setOpenSection]=useState('details');
  let initial_values=useRef();
  function onSubmit(ps){
    let params=JSON.parse(JSON.stringify(ps));
    //IF YOU DEVIATE FROM THE DB STRUCTURE YOU MUST REFLECT THAT IN THE CHECKLIST WHEN CHANGING STAGE.
    //let custom_deal_fields=[];
    //for(let key in params){
    //  if(key.includes('cus_deal_field_')){for(let val of params[key]){custom_deal_fields.push({id:key.replace('cus_deal_field_', ''), value:val});} delete params[key]}
    //}
    //params['custom_deal_fields']=custom_deal_fields;
    params.company_id=props.company.id
    if(props.deal==undefined){props.createDeal(params);}else{props.updateDeal(params.id, params);}
  }

  let custom_fields=[];
  if(props.workspace!=undefined){
    for(let wf of props.workspace.workspace_fields){
      if(wf.entity_type=='DEAL'){
        custom_fields.push(wf);
    }}
  }



  let contacts_initial=[];
  let custom_fields_initial={};
  if(props.deal!=undefined){
//    for(let cdfo of props.deal.custom_deal_field_options){
//      if(custom_fields_initial['cus_deal_field_'+cdfo.custom_deal_field_id]==undefined){
//      custom_fields_initial['cus_deal_field_'+cdfo.custom_deal_field_id]=[cdfo.id]
//    }else{
//      custom_fields_initial['cus_deal_field_'+cdfo.custom_deal_field_id].push(cdfo.id);
//    }
//    }
    for(let c of props.deal.contacts){contacts_initial.push(c.id);}
  }
  console.log(contacts_initial, 'CONTACTS INITIAL');


  let default_pipeline=(props.deal_pipelines==undefined)?null:props.deal_pipelines[0].id;
  let select_deal_pipelines=[]; if(props.deal_pipelines!=undefined){for(let p of props.deal_pipelines){if(p.active==true && p.id==props.workspace.deal_auto_pipeline_id){default_pipeline=p.id;}else if(p.default==true && p.active==true && default_pipeline==undefined){default_pipeline=p.id;} if(p.active==true || (props.deal!=undefined && props.deal.deal_pipeline_id==p.id)){select_deal_pipelines.push(p);}}}
  let initial_contact_ids=[];
  for(let c of props.company.contacts){if(c.pivot.working_contact==true){initial_contact_ids.push(c.id);}}
  if(initial_contact_ids.length==0 && props.company.contacts.length>0){initial_contact_ids=[props.company.contacts[0].id]}
  if(initial_values.current==undefined || (initial_values.current.id!=undefined && props.deal!=undefined && initial_values.current.id!=props.deal.id)){
    initial_values.current=(props.deal==undefined)?{name:(props.workspace!=undefined && props.workspace.deal_auto_create_name!=undefined)?props.workspace.deal_auto_create_name:'New deal', outcome:20, main:false, deal_pipeline_id:default_pipeline, contacts:initial_contact_ids}:{...props.deal, ...custom_fields_initial, contacts:contacts_initial}
  }
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_values.current}
      handleClose={props.handleClose}
      >
      {form_props => (
    <form autocomplete='off' onSubmit={form_props.handleSubmit}>
    <Popup handleClose={props.handleClose} always_open title={(props.deal!=undefined)?'prospect_deal_update_popup_title':'prospect_deal_create_popup_title'} closed={()=>{form_props.form.reset();}} align='right' accept_button_click={()=>{form_props.form.submit();}} content={
      <div style={{minHeight:'500px'}}>
      <Grid container style={{marginTop:'20px', marginBottom:'20px', marginLeft:'20px', width:'calc(100% - 40px)'}}>
      <Grid item xs={6}><Text required title='Name' name='name'/></Grid>
      <Grid item xs={6}><Text required title='Value' type='number' name='value' currency step=".01"/></Grid>
      {(props.deal_pipelines==undefined)?null:<Grid item xs={6}><Select size='small' style={{marginBottom:'10px'}} variant='outlined' title='Pipeline' name='deal_pipeline_id' select_data={select_deal_pipelines}/></Grid>}
      {(props.deal_pipelines==undefined)?null:<Grid item xs={6}><Field name='deal_pipeline_id'>{(f)=>{let deal_stages_data=[]; for(let dp of props.deal_pipelines){if(dp.id==f.input.value){deal_stages_data=dp.deal_stages;}} return(<Field name='deal_stage_id'>{(ff)=>{let stop=false; for(let ds of deal_stages_data){if(ds.id==ff.input.value){stop=true;}} if(stop==false){ff.input.onChange(deal_stages_data[0].id)} return(<Select size='small' style={{marginBottom:'10px'}} variant='outlined' title='Stage' name='deal_stage_id' select_data={deal_stages_data}/>)}}</Field>)}}</Field></Grid>}
      {(props.deal_pipelines==undefined)?null:<Grid item xs={6}><Field name='outcome'>{(fff)=><Field name='deal_pipeline_id'>{(ff)=><Field name='deal_stage_id'>{(f)=>{let stage=null; for(let dp of props.deal_pipelines){if(dp.id==ff.input.value){for(let ds of dp.deal_stages){if(ds.id==f.input.value){stage=ds;}}}}
      let outcomes=[{id:20, name:'Cold'}, {id:21, name:'Warm'}, {id:22, name:'Dead'}];
      if(stage!=null && stage.type==1){outcomes=[{id:7, name:'Open'}, {id:8, name:'Won'}, {id:9, name:'Lost'}]}
      else if(stage!=null && stage.type==0){outcomes=[{id:0, name:'Open'}, {id:1, name:'Try later'}, {id:2, name:'Unqualified'}, {id:3, name:'Lost'}]}
      let done=false; for(let o of outcomes){if(props.deal==undefined || stage.id!=props.deal.deal_stage_id || o.id==props.deal.outcome){done=true;}} if(done==false){let i=props.deal.outcome; outcomes.push({id:i, name:(i==20)?'Cold':(i==21)?'Warm':(i==22)?'Dead':(i==7)?'Open':(i==8)?'Won':(i==9)?'Lost':(i==0)?'Open':(i==1)?'Try later':(i==2)?'Unqualified':(i==3)?'Lost':undefined});}else{
        if(stage==null || (stage.type==2 && fff.input.value<19)){fff.input.onChange(20);}else if(stage!=null && stage.type==0 && fff.input.value>3){fff.input.onChange(0);}else if(stage!=null && stage.type==1 && (fff.input.value<7 || fff.input.value>19)){fff.input.onChange(7);}
      }


      return(<Fragment><Select style={{marginBottom:'10px'}} size='small' variant='outlined' title='Deal status' name='outcome' select_data={outcomes}/></Fragment>)
      }}</Field>}</Field>}</Field></Grid>}
      <Grid item xs={6}><Field name='date_time'>{(f)=><Date_picker date_time title='Date' value={f.input.value} onChange={f.input.onChange}/>}</Field></Grid>
      <Grid item xs={6}><div style={{marginLeft:'10px'}}><FormControlLabel control={<Field name='main'>{(f)=><Checkbox disabled={(props.deal!=undefined && props.deal.main==true)?true:false} checked={f.input.value} onChange={f.input.onChange} name="main" />}</Field>} label="Primary deal" /></div></Grid>
      <Grid item xs={12}><Grid container>{(custom_fields.length>0)?<CustomFieldsSection {...props}  type="DEAL" open_section={open_section} setOpenSection={setOpenSection}/>:null}</Grid></Grid>
      <Grid item xs={12}><DealDetailsSection {...props} open_section={open_section} setOpenSection={setOpenSection}/></Grid>
      </Grid>
      </div>
    } submit_button button_variant={'none'}  accept_button={'Save'}/>
      </form>
    )}</Form>
  );
}

//force_content={(window.location.href.includes('test.prospectsafari.com') || window.location.href.includes('localhost'))?null:
//  <Fragment>{custom_fields.map(function(cf){
//    let sd=[]; for(let so of cf.custom_deal_field_options){if(so.deleted_at==null){sd.push(so);}}
//    return(<Grid item xs={6} style={{marginTop:'10px'}}><Field name={'cus_deal_field_'+cf.id}>{(f)=><MultipleSelect size='small' variant='outlined' with_id title={cf.name} value={f.input.value} onChange={f.input.onChange} name={'cus_deal_field_'+cf.id} select_data={sd} />}</Field></Grid>)
//  })}</Fragment>
//}

export default connect(ss, dd)(Deal_popup_form);


function ss(state){
  return{}
}

function dd(dispatch){
  return{
    createDeal:(data)=>{dispatch({type:'REQUEST_CREATE_DEAL', data:data})}
  }
}
